<template>
  <div id="app" v-cloak>
    <router-view/>
  </div>
</template>

<script>
  document.title='\u200E';
</script>

